import { createFileRoute, Outlet } from "@tanstack/react-router";
import { CalendarCheck } from "lucide-react";
import { CockpitModuleGate } from "@/components/cockpit/CockpitModuleGate";

export const Route = createFileRoute("/_cockpit/cockpit/hundert-tage")({
  head: () => ({
    meta: [
      { title: "100 Tage im Amt – Cockpit – creategy" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <CockpitModuleGate module="hundert_tage">
      <HundertTageLayout />
    </CockpitModuleGate>
  ),
});

/** Ticket Z4: Modulrahmen mit Kopfbereich; Inhalte in den Kindrouten. */
function HundertTageLayout() {
  return (
    <div className="space-y-6">
      <header className="flex items-start gap-3">
        <div className="rounded-md bg-primary/10 p-2 text-primary">
          <CalendarCheck className="h-5 w-5" aria-hidden />
        </div>
        <div>
          {/* Modulband, keine Überschrift: die Hauptüberschrift (h1) liefert
              jede Unterseite selbst – so bleibt genau ein h1 pro Seite. */}
          <p className="font-display text-2xl font-extrabold text-foreground">100 Tage im Amt</p>
          <p className="mt-1 text-sm text-muted-foreground">
            Ihr Begleitmodul für den Amtsstart.
          </p>
        </div>
      </header>

      <Outlet />
    </div>
  );
}
